import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: [],
  },
  getters: {
    list: (state) => state.list,
  },
  actions: {
    fetchOrderPayments({ commit }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Sales/api/BankPaymentsQuery/basket/" + id)
          .then((r) => {
            commit("setList", r.data);
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },
    addPaymentConfirmation({ commit }, detail) {
      var body = {
        bankPaymentIdInWebsite: 0,
        cashPaymentId: detail.id,
        bankStatus: detail.bankStatus,
        description: detail.description,
      };
      return ajax.put("Sales/api/BankPayments/0/0", body).then((r) => {});
    },
    createOrderPayment({ commit, dispatch }, model) {
      return ajax.post("Sales/api/BankPayments/cash", model).then((r) => {});
    },
    updateOrderPayment({ commit, dispatch }, model) {
      return ajax.put("Sales/api/BankPayments/cash", model).then((r) => {});
    },
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    },
  },
};
